import React, { Component } from 'react';
import Helmet from 'react-helmet';

import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import { Container, Col, Row } from 'reactstrap';
import TextBox from '@components/TextBox/TextBox';
import ImportImages from '@src/importImages';

const Image = ImportImages('/suitedeals/suitedeals.jpg');

// import Css from './Charter.scss';

class BrokerRelations extends Component {
  render() {
    let height = window.innerHeight;

    let styles = {};
    let classNames = '';
    if (window.innerWidth < 992) {
      styles.minHeight = this.props.pageHeight + 'px';
      styles.backgroundImage = `url(${Image})`;
      styles.backgroundSize = 'auto 100%';
      styles.backgroundPosition = 'center center';
      classNames = 'pt-6 pb-4';
    } else {
      styles.height = this.props.pageHeight + 'px';
      classNames = 'abs-container d-flex align-items-center';
    }

    const props = {
      header: 'Wholesale',
      content:
        'Sourcing the very best charter option for your clients?<br/><br/>JetSuite provides the' +
        ' wholesale community piece of mind by offering top-of-class customer service, efficiency and safety that' +
        ' clients expect from a business aviation operator.',
      link: {
        url: 'mailto:charter@jetsuite.com',
        label: 'Contact the Team'
      }
    };

    const containerProps = {
      pageHeight: height,
      hideNavDots: true
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>Broker Relations | JetSuite</title>
          <meta
            name="description"
            content={'Sourcing the very best charter option for your clients?'}
          />
        </Helmet>
        <ScrollContainer {...containerProps}>
          <div
            id={'charter-list'}
            className={'panel d-flex align-items-center'}
            style={styles}
          >
            <img
              src={Image}
              alt={'Slider1'}
              className={'img-fluid d-none d-md-block'}
            />
            <Container fluid={true} className={classNames}>
              <Row className={'justify-content-center'}>
                <Col md={10} xs={12}>
                  <Row>
                    <Col md={this.props.heightSm ? 7 : 6} xs={12}>
                      <TextBox {...props} isHeader={true} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </ScrollContainer>
      </React.Fragment>
    );
  }
}

export default BrokerRelations;



// WEBPACK FOOTER //
// ./src/components/BrokerRelations/BrokerRelations.js